var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"menu",on:{"click":function($event){return _vm.$emit('actionClicked')}}},[(_vm.canEdit)?_c('li',{staticClass:"menu__item"},[_c('RouterLink',{staticClass:"menu__link",attrs:{"to":{
        name: `${_vm.routeBaseName}.edit`,
        params: {
          ...this.$route.params,
          pageId: _vm.pageId,
        },
      }}},[_vm._v(" "+_vm._s(_vm._f("capitalize")(_vm.$t('global.edit')))+" ")])],1):_vm._e(),(_vm.canDelete)?_c('li',{staticClass:"menu__item"},[_c('RouterLink',{staticClass:"menu__link",attrs:{"to":{
        name: `${_vm.routeBaseName}.delete`,
        params: {
          ...this.$route.params,
          pageId: _vm.pageId,
        },
      }}},[_vm._v(" "+_vm._s(_vm._f("capitalize")(_vm.$t('delete')))+" ")])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }